import type { PageableResponse, ScheduleEvent } from '~/types'

export const useLoadScheduleEvents = (params: MaybeRef<ScheduleEvent.SearchRequest> = {}) => {
  const { search } = useScheduleEventApi()
  const isLoading = ref<boolean>(false)

  const { handleException } = useHandleException()

  const { fetchGenerator } = useFetchGenerator<ScheduleEvent.Model>()

  const fetchAllData = async (): Promise<ScheduleEvent.Model[]> => {
    const data: ScheduleEvent.Model[] = []
    isLoading.value = true

    const fetchPage = (page: number): Promise<PageableResponse<ScheduleEvent.Model>> =>
      search({ ...unref(params), page })

    // @ts-expect-error Fix unknown type for fetch generator (obviously nobody will fix it :D)
    for await (const response of fetchGenerator(fetchPage)) {
      response.data.forEach((scheduleEvent: ScheduleEvent.Model) => {
        data.push(scheduleEvent)
      })
    }
    isLoading.value = false

    return data
  }

  const fetchData = async (): Promise<PageableResponse<ScheduleEvent.Model>> => {
    isLoading.value = true
    try {
      return await search(params)
    }
    catch (ex: unknown) {
      handleException(ex)

      throw ex
    }
    finally {
      isLoading.value = false
    }
  }

  return {
    isLoading,

    fetchData,
    fetchAllData,
  }
}
